module.exports = __webpack_public_path__ + "img/sunset-girl.94aaa4f8.jpg";